import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogContentText, DialogActions, DialogTitle, Button, Typography } from '@material-ui/core';
import { Markup } from 'interweave';

const ExpandableComment = ({ Comment, CommentLimit, DarkColor }) => {
    const [open, setOpen] = React.useState(false);
    const [commentTextProps, setCommentTextProps] = React.useState(Comment);
    const [commentLimitProps, setCommentLimitProps] = React.useState(CommentLimit);

    const findLargeWordStartIndex = (str, length) => {
        const words = str.split(" ");
        const largeWordIndex = words.findIndex((word) => word.length > length);

        if (largeWordIndex === -1) {
            return -1;
        }

        let startIndex = 0;
        for (let i = 0; i < largeWordIndex; i++) {
            startIndex += words[i].length + 1; // Kelimeler arası boşlukları da hesaba katmak için +1 ekleniyor.
        }

        return startIndex;
    }

    const ExpandableCommentText = ({ CommentText }) => {
        // const colorText = selectedIndex !== RowId ? '#FF9800' : '#000000';
        const colorText = DarkColor ? '#000000' : '#FF9800';
        const wordLargeThan20CharIndex = findLargeWordStartIndex(CommentText, commentLimitProps / 5);

        if (wordLargeThan20CharIndex !== -1 && CommentText?.length <= commentLimitProps) {
            setCommentLimitProps(wordLargeThan20CharIndex + 13);
        }


        if (CommentText?.length > commentLimitProps) {
            return (
                <>{CommentText.substring(0, commentLimitProps)}
                    <a
                        href='#'
                        style={{
                            color: colorText,
                            textDecoration: 'none',
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            setOpen(true)
                        }}>...Daha Fazla
                    </a>
                </>
            );
        } else {
            return (
                <><Markup content={CommentText} /></>
            );
        }
    }
    return (
        <>
            <ExpandableCommentText CommentText={commentTextProps} />
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Yorum Detayı</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Typography style={{ wordWrap: 'break-word' }}>
                            <Markup content={commentTextProps} />
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="primary">
                        Tamam
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ExpandableComment;
